import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import { Box, Typography } from '@mui/material';
import Container from '@mui/material/Container';

import { useTranslate } from 'src/locales';
import Header from 'src/layouts/modules/header';
import { useAuthContext } from 'src/auth/hooks';
import { useEntityContext } from 'src/entity/hooks';

import Iconify from 'src/components/iconify';
import MyEntitiesMenu from 'src/components/myentities-menu';
import NavItemHorizontal from 'src/components/nav-section/horizontal/nav-item';

// ----------------------------------------------------------------------

export default function ModuleLayout({ children }) {
  const { t } = useTranslate();
  const { entity } = useEntityContext();
  const {
    logout,
    user: {
      userData: { firstname },
    },
  } = useAuthContext();

  if (!entity) {
    return null;
  }

  const { name, logo } = entity;

  return (
    <Container component="main">
      <Header />
      <Stack
        gap={{ xs: 2, sm: 4, md: 6, lg: 8 }}
        sx={{
          pt: { xs: 12, md: 24 },
          pb: 4,
          m: 'auto',
          minHeight: '100vh',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          transition: (theme) => theme.transitions.create(['gap']),
        }}
      >
        <div title={name}>
          <MyEntitiesMenu
            size="small"
            sx={{
              textAlign: 'left',
              borderRadius: 1,
              fontSize: 11,
              cursor: 'pointer',
              typography: 'overline',
              display: 'block',
              color: 'text.disabled',
              width: '100%',
              transition: (theme) =>
                theme.transitions.create(['color'], {
                  duration: theme.transitions.duration.shortest,
                }),
              '&:hover': {
                color: 'primary.contrastText',
              },
            }}
          >
            <Box
              component="img"
              src={logo}
              alt={name}
              sx={{ width: '100%', height: 75, objectFit: 'contain' }}
            />
          </MyEntitiesMenu>
        </div>

        <Stack>
          <Typography textTransform="uppercase" variant="h4">
            {t('modules.welcome.title', { firstname })}
          </Typography>
          <Typography fontStyle="italic" variant="subtitle1">
            {t('modules.welcome.subtitle')}
          </Typography>
        </Stack>

        {children}

        <Box sx={{ flex: 1 }} />

        <NavItemHorizontal
          title={t('common.logoff')}
          icon={<Iconify icon="material-symbols:logout-rounded" />}
          onLinkClick={logout}
        />
      </Stack>
    </Container>
  );
}

ModuleLayout.propTypes = {
  children: PropTypes.node,
};
